// This new file will be possibly integrated with old ones
// Different name for separation reasons
import axios from "axios";

// DEVICES page: Fetch all devices of a house
export const getDevicesByHouse = (houseId) => {
    return new Promise(((resolve, reject) => {
        axios.get(`/house/getalldevices/${houseId}`)
            .then(response => resolve(response))
            .catch(error => reject(error))
    }))
}

// DEVICES page: Fetch device's consumption last hour
export const getDeviceConsumptionLast24h = (deviceId, deviceRelay) => {
    return new Promise(((resolve, reject) => {
        axios.get(`/data/device/lastday/${deviceId}/${deviceRelay}`)
            .then(response => resolve(response))
            .catch(error => reject(error))
    }))
}

// DEVICES page: Delete device
export const deleteDevice = (deviceId) => {
    return new Promise(((resolve, reject) => {
        axios.delete(`/device/delete/${deviceId}`)
            .then(response => resolve(response))
            .catch(error => reject(error))
    }))
}

// DEVICES page: Update device name
export const updateDeviceName = (deviceId, name) => {
    return axios.put(`/device/update/${deviceId}`, { name });
};

// DEVICES page: Toggle boiler switch (ON/OFF)
export const toggleBoilerSwitch = (deviceId) => {
    return new Promise((resolve, reject) => {
        axios.post(`/rpc/shellies/toggle-switch?device_id=${deviceId}`, {})
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};

// DEVICES page: Fetch device schedules
export const getDeviceSchedules = (deviceId) => {
    return new Promise((resolve, reject) => {
        axios.get(`/rpc/shellies/get-simplified-schedules/${deviceId}`)
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};

// DEVICES page: Set/Update/Delete device schedule
export const setDeviceSchedule = (deviceId, scheduleData) => {
    return new Promise((resolve, reject) => {
        axios.post(`/rpc/shellies/set-schedule`, {
            device_id: deviceId,
            ...scheduleData
        })
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};